import { setDefaultOptions } from 'date-fns';
import { useEffect, useState } from 'react';
import { enUS } from 'date-fns/locale';

export const loadDateFnsLocale = async (locale: string): Promise<any> => {
    return await import(`date-fns/locale/${locale}/index.js`);
};

export const useDateFnsLocale = (l: string) => {
    const [locale, setLocale] = useState<any>(enUS);

    useEffect(() => {
        let isMounted = true; // Flag to track if the component is mounted

        loadDateFnsLocale(l).then(data => {
            if (isMounted && data) {
                // Only update state if the component is still mounted
                setLocale(data.default);
                setDefaultOptions({ locale: data.default });
            }
        });

        return () => {
            isMounted = false; // Cleanup function to set the flag to false when the component unmounts
        };
    }, [l]);

    return locale;
};
